module.exports = __webpack_public_path__ + "img/builder-11.ec4e0654.jpg";